import $ from 'jquery';

export const els = {
	viewport: $(window),
	header: $(".site-header"),
	masthead: $(".masthead")
};

export const constants = {
	scrollTopOffset: 40,
	speed: 300,
	easing: "ease-in-out"
}

export const breakpoints = {
	xs: 480,
	sm: 768,
	md: 992,
	lg: 1200
}
